export const COLORS = Object.freeze({
  primary: '#252525',
  bgGrey: '#01404F05',
  borderBlack: '#383838',

  blue: '#01404F',
  blue2: '#0A93B4',

  black: '#252525',
  black2: '#404040',
  black3: 'rgba(0, 0, 0, 0.25)',
  black4: '#000000B8',
  black5: '#21212178',

  red: '#F56666',
  red2: '#FF0C0C',
  red3: '#FF2121',

  white: '#FBFBFB',
  white2: '#FCFCFC',
  white3: '#F1F1F1',

  grey1: '#C4C4C4',
  grey2: '#6F6F6F',
  grey3: '#E6E6E6',
  grey4: '#737373',
  grey5: '#A0A0A096',
  grey6: '#A5A5A5',
  grey7: '#757575',
  grey8: '#848484',
  grey9: '#E5E5E5',
  grey10: '#D9D9D95E',
  grey11: ' #ABABAB',
  grey12: '#D9D9D9',

  green: '#0AB476',
  green2: '#14DE00',
  green3: '#7FDB76',
  green4: '#039000',

  dividerBlue: '#01404F1C',

  yellow: '#EBD043',

  // --- Modern crisp teal + white palette (Phase 2 redesign) ---
  // Deep teal brand as the hero accent on a crisp cool-white base. Cool neutral
  // greys (not warm cream), pure-white cards, near-black cool ink, and cool
  // hairlines. New tokens are additive — legacy tokens above stay so existing
  // screens keep working while pages are migrated per phase.
  tealDark: '#012A34', // hover / pressed teal
  teal: '#01404F', // brand primary (rgb(1,64,79) — same hue as `blue`)
  tealMid: '#0A5A6E', // lighter teal for gradients
  tealSoft: '#E8F1F2', // tinted teal surface / wash
  tealTint: '#F2F8F9', // faintest teal hover wash
  ink: '#0E1B1F', // primary text (near-black, cool)
  inkSoft: '#5B6B6E', // secondary text (cool grey)
  inkFaint: '#8A989B', // tertiary / placeholder text
  canvas: '#F5F7F8', // page background (cool light grey)
  surface: '#FFFFFF', // cards / paper (pure white)
  surfaceAlt: '#EEF2F3', // subtle alt surface (cool)
  hairline: '#E6EAEB', // cool 1px borders / dividers
  hairlineStrong: '#D3DADC', // stronger cool border
  brass: '#B08D57', // legacy accent (retired from prominent use)
  brassSoft: '#F3ECE0',

  // Signature gradients / effects for the modern look.
  heroGradient:
    'linear-gradient(103deg, rgba(1,42,52,0.92) 0%, rgba(1,64,79,0.7) 42%, rgba(10,90,110,0.28) 100%)',
  tealGradient: 'linear-gradient(135deg, #01404F 0%, #0A5A6E 100%)',
  glassBg: 'rgba(255,255,255,0.72)',
});
